import React from 'react';
import { Modal, Form, Input, Button, Descriptions, message } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import Lang from '../../../common/model/global/Lang';
import StringUtil from '../../../common/util/StringUtil';

interface ExportAuditModalProps {
  visible: boolean;
  matter: any; // 文件/文件夹对象
  user: any; // 当前用户
  onClose: () => void;
  onSubmit: (data: ExportAuditData) => void;
}

interface ExportAuditData {
  matterUuid: string;
  fileName: string;
  path: string;
  size: number;
  applicant: string;
  reason: string;
}

const ExportAuditModal: React.FC<ExportAuditModalProps> = ({
  visible,
  matter,
  user,
  onClose,
  onSubmit
}) => {
  const [form] = Form.useForm();
  const [confirmLoading, setConfirmLoading] = React.useState(false);

  // 处理表单提交
  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setConfirmLoading(true);
      
      const exportData: ExportAuditData = {
        matterUuid: matter.uuid,
        fileName: matter.name,
        path: matter.path,
        size: matter.size,
        applicant: user.username,
        reason: values.reason
      };
      
      await onSubmit(exportData);
      message.success(Lang.t('matter.opsuccess'));
      form.resetFields();
      onClose();
    } catch (error) {
      console.error('Validation failed:', error);
    } finally {
      setConfirmLoading(false);
    }
  };

  // 处理取消
  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title={
        <span>
          <ExportOutlined style={{ marginRight: 8 }} />
          {Lang.t('matter.exportAudit')}
        </span>
      }
      visible={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          {Lang.t('cancel')}
        </Button>,
        <Button 
          key="submit" 
          type="primary" 
          loading={confirmLoading}
          onClick={handleSubmit}
        >
          {Lang.t('submit')}
        </Button>,
      ]}
      width={600}
      destroyOnClose
    >
      <Descriptions column={1} bordered size="small" className="mb-20">
        <Descriptions.Item label={Lang.t('matter.fileName')}>
          {matter?.name || '--'}
        </Descriptions.Item>
        <Descriptions.Item label={Lang.t('matter.path')}>
          {matter?.path || '--'}
        </Descriptions.Item>
        <Descriptions.Item label={Lang.t('matter.size')}>
          {matter?.size ? StringUtil.humanFileSize(matter.size) : '--'}
        </Descriptions.Item>
        <Descriptions.Item label={Lang.t('user.username')}>
          {user?.username || '--'}
        </Descriptions.Item>
      </Descriptions>

      <Form
        form={form}
        layout="vertical"
        name="exportAuditForm"
      >
        <Form.Item
          name="reason"
          label={Lang.t('matter.reason')}
          rules={[
            { required: true, message: Lang.t('matter.reason') },
            { max: 500, message: Lang.t('matter.exportReasonMaxLength') }
          ]}
        >
          <Input.TextArea
            rows={4}
            placeholder={Lang.t('matter.reason')}
            showCount
            maxLength={500}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ExportAuditModal;